/** msec の時間スリープする */
export async function sleep(msec: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, msec));
}
